// export default async function _getPublications() {
//     // Grab username from the meta tag
//     const profileUsernameEl = document.querySelector(
//         'meta[name="profileUsername"]'
//     );
//     const publicationContainer = document.querySelector(
//         '.publication-list-container-js'
//     );

//     if (profileUsernameEl && publicationContainer) {
//         const username = profileUsernameEl.content;

//         // Fetch those publications
//         const response = await fetch(
//             `https://www.otago.ac.nz/api/publications?username=${username}`
//         );
//         const p = await response.json();

//         // Collate the TOP and OTHER publications into a single array
//         const publications = [];
//         for (let i = 0; i < p.data.TOP.length; i++) {
//             publications.push(p.data.TOP[i]);
//         }
//         for (let i = 0; i < p.data.OTHER.length; i++) {
//             const category = p.data.OTHER[i];
//             for (let j = 0; j < category.PUBLICATIONS.length; j++) {
//                 publications.push(category.PUBLICATIONS[j]);
//             }
//         }

//         if (publications.length > 0) {
//             // Create and append publication elements
//             for (let i = 0; i < publications.length; i++) {
//                 const publication = publications[i];
//                 const div1 = document.createElement('div');
//                 div1.className = 'publication-item person-profile';
//                 if (i > 4) {
//                     div1.className += ' hidden';
//                 }
//                 div1.innerHTML = publication.CITATION;

//                 const div2 = document.createElement('div');
//                 div2.className = 'publication__tag';
//                 div2.innerHTML = publication.CATEGORY_DESCRIPTION;

//                 div1.appendChild(div2);
//                 publicationContainer.appendChild(div1);
//             }

//             // Insert button
//             // (We may have implemented this differently but there is some code in main.js which handles toggling)
//             const togglePublicationsBtn = document.createElement('button');
//             togglePublicationsBtn.className =
//                 'toggle-publications person-profile__publication-toggle';
//             togglePublicationsBtn.innerHTML = 'More publications';
//             publicationContainer.appendChild(togglePublicationsBtn);

//             const publicationItems =
//                 publicationContainer.querySelectorAll('.publication-item');
//             let isClicked = false;

//             togglePublicationsBtn.addEventListener('click', (e) => {
//                 e.preventDefault();
//                 if (!isClicked) {
//                     isClicked = true;
//                     togglePublicationsBtn.innerHTML = 'Fewer Publications';
//                     publicationItems.forEach((publication) => {
//                         publication.classList.remove('hidden');
//                     });
//                 } else {
//                     isClicked = false;
//                     togglePublicationsBtn.innerHTML = 'More Publications';
//                     let j = 0;
//                     if (publicationItems) {
//                         publicationItems.forEach((publication) => {
//                             j += 1;
//                             if (j > 5) {
//                                 publication.classList.add('hidden');
//                             }
//                         });
//                     }
//                 }
//             });
//         }
//     }
// }

// _getPublications();
